<template lang="pug">
  #send-document-category-list(v-cloak)
    .box
      .box-header.register-header.d-flex.flex-row
        .title
          span 文書種類
        .flex-fill.d-flex.flex-row-reverse
          button.btn.back-btn(@click="gotoSendDocumentList" type="button") 戻る
          button.btn.add-btn(v-if="_showCategoryEdit" @click="gotoCategoryEdit" type="button") 編集
      .box-body
        CategoryTable(v-model="items" :fields="fields" :isLoading="isLoading")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import { PcUrl } from "@/commons/constants/PcUrl";

import SendDocumentCategoriesService, { SendDocumentCategoryGetModel } from "@/commons/services/SendDocumentCategories";

import CategoryTable, { CategoryTableField, CategoryTableItem } from "@/pc/containers/sendDocuments/CategoryTable.vue";

/**
 * ### 文書送付一覧画面コンポーネント
 */
@Component({
  components: {
    CategoryTable
  }
})
export default class CategoryList extends Vue {
  /** 文書送付カテゴリーサービス */
  @Inject("SendDocumentCategoriesService") categoriesService!: SendDocumentCategoriesService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** テーブル列名 */
  fields: Array<CategoryTableField> = [];
  /** テーブル各行の情報 */
  items: Array<CategoryTableItem> = [];
  /** 読込み中か否か */
  isLoading: boolean = true;

  get _showCategoryEdit(): boolean {
    return userStore.loginUser.permissions.sendDocumentsFunction.useEdit;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    // 画面初期表示時に作成して変更しないものを初期化する
    const fields: Array<CategoryTableField> = this.createFields();
    this.fields = fields;

    // 動的に変更する画面情報を作成する
    this.items = [];
    await this.createView();

    return;
  }

  /**
   * ### テーブル列名を作成する
   */
  public createFields(): Array<CategoryTableField> {
    let fields: Array<CategoryTableField> = [];

    fields.push({ key: "no", label: "番号", sortable: false, sortDirection: "desc", class: "no" });
    fields.push({ key: "enabled", label: "使用", sortable: false, sortDirection: "desc", class: "enabled text-center" });
    fields.push({ key: "name", label: "種類名", sortable: false, sortDirection: "desc", class: "name" });
    fields.push({ key: "description", label: "説明", sortable: false, sortDirection: "desc", class: "description" });

    return fields;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    this.isLoading = true;

    // テーブルに渡す各プロパティを作成する
    const sendDocumentCategories: Array<SendDocumentCategoryGetModel> = await this.getSendDocumentCategories();
    const items: Array<CategoryTableItem> = this.createItems(sendDocumentCategories);
    this.items = this.items.concat(items);

    this.isLoading = false;

    return;
  }

  /**
   * ### 文書送付カテゴリーを取得する
   */
  public async getSendDocumentCategories(): Promise<Array<SendDocumentCategoryGetModel>> {
    const response: Array<SendDocumentCategoryGetModel> = await this.categoriesService.gets(userStore);

    return response;
  }

  /**
   * ### テーブル行を作成する
   */
  public createItems(categories: Array<SendDocumentCategoryGetModel>): Array<CategoryTableItem> {
    let items: Array<CategoryTableItem> = [];

    for (const category of categories) {
      items.push(category);
    }

    return items;
  }

  /**
   * ### 文書送付一覧画面へ遷移する
   */
  public gotoSendDocumentList(): void {
    this.$router.push(PcUrl.SendDocumentList);
    return;
  }

  /**
   * ### 文書送付カテゴリー編集画面へ遷移する
   */
  public gotoCategoryEdit(): void {
    this.$router.push(PcUrl.SendDocumentCategoryEdit);
    return;
  }
}
</script>

<style lang="scss" scoped>
// 親要素からネストしてスタイルを指定する
#send-document-category-list {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .box-header {
    width: 100%;

    .back-btn,
    .add-btn {
      width: 80px;
      min-width: 80px;
    }
    .add-btn {
      margin-right: 8px;
    }
  }
}
</style>
